// src/admin/lib/supabase.ts
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/lib/database.types';
import { env } from './env';

export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: 'thandizo-admin-auth',
      flowType: 'pkce',
    },
    global: {
      headers: { 'x-client-info': 'thandizo-admin/0.1' },
    },
  },
);

export type SupabaseClient = typeof supabase;
